export default "__VITE_ASSET__MprwqMnQ__"